import { CalculateServiceCostResult, Service } from '@anispi-reporting-system/types';
import { useState } from 'react';

interface UploadFile {
  filename: string;
  uploadKey: string;
}

const useForm = () => {
  const [companyName, setCompanyName] = useState('');
  const [companyNo, setCompanyNo] = useState('');
  const [officeNo, setOfficeNo] = useState('');
  const [service, setService] = useState<Service>('RS');
  const [uploadFileSe, setUploadFileSe] = useState<UploadFile>({
    filename: '',
    uploadKey: '',
  });
  const [uploadFileSv, setUploadFileSv] = useState<UploadFile>({
    filename: '',
    uploadKey: '',
  });
  const [serviceCost, setServiceCost] = useState<CalculateServiceCostResult['serviceCost'] | undefined>(undefined);

  return {
    companyName,
    companyNo,
    officeNo,
    service,
    serviceCost,
    setCompanyName,
    setCompanyNo,
    setOfficeNo,
    setService,
    setServiceCost,
    setUploadFileSe,
    setUploadFileSv,
    uploadFileSe,
    uploadFileSv,
  };
};

export { useForm };
export type { UploadFile };
